<template>
  <div class="af3-floor-plan-gallery" ref="root">
    <div class="swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="image in filtered_floorplan_gallery" :key="image">
          <div class="image-container">
            <img :src="image" alt="Floor Plan Image" class="floor-plan-image" />
          </div>
        </div>
      </div>
      <div v-if="options.floor_plans_loop_show_gallery && filtered_floorplan_gallery.length > 1" class="swiper-button-prev">
        <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="23.277" height="20.619" viewBox="0 0 23.277 20.619">
            <defs>
                <clipPath id="clip-path">
                <rect id="Rectangle_455" data-name="Rectangle 455" width="23.277" height="20.619" transform="translate(0 0)" fill="none"/>
                </clipPath>
            </defs>
            <g id="Group_5292" data-name="Group 5292" transform="translate(0 0)">
                <g id="Group_5291" data-name="Group 5291" clip-path="url(#clip-path)">
                <path id="Path_46212" data-name="Path 46212" d="M12.968,20.619a1,1,0,0,1-.707-1.707l7.6-7.6H1a1,1,0,0,1,0-2H19.864l-7.6-7.6A1,1,0,0,1,13.675.293L22.985,9.6l.022.024h0s0,0,0,0h0a1,1,0,0,1,.267.68v0a1,1,0,0,1-.265.675h0l0,0c-.009.008-.017.017-.025.025l-9.31,9.31a1,1,0,0,1-.707.293" fill="#111e1a"/>
                </g>
            </g>
        </svg>
      </div>
      <div v-if="options.floor_plans_loop_show_gallery && filtered_floorplan_gallery.length > 1" class="swiper-button-next">
        <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="23.277" height="20.619" viewBox="0 0 23.277 20.619">
            <defs>
                <clipPath id="clip-path">
                <rect id="Rectangle_455" data-name="Rectangle 455" width="23.277" height="20.619" transform="translate(0 0)" fill="none"/>
                </clipPath>
            </defs>
            <g id="Group_5292" data-name="Group 5292" transform="translate(0 0)">
                <g id="Group_5291" data-name="Group 5291" clip-path="url(#clip-path)">
                <path id="Path_46212" data-name="Path 46212" d="M12.968,20.619a1,1,0,0,1-.707-1.707l7.6-7.6H1a1,1,0,0,1,0-2H19.864l-7.6-7.6A1,1,0,0,1,13.675.293L22.985,9.6l.022.024h0s0,0,0,0h0a1,1,0,0,1,.267.68v0a1,1,0,0,1-.265.675h0l0,0c-.009.008-.017.017-.025.025l-9.31,9.31a1,1,0,0,1-.707.293" fill="#111e1a"/>
                </g>
            </g>
        </svg>
      </div>
    </div>
  </div>

  
</template>
  
<script>
import { defineComponent, ref, computed, watch, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export default defineComponent({
    components: { },
   
    props: {
        floorplan_gallery: {
            type: Array,
            required: true
        },
        options: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },

    setup(props) {
        const root = ref(null);
        let swiper = null;

        const filtered_floorplan_gallery = computed(() =>
            props.options.floor_plans_loop_show_gallery
                ? props.floorplan_gallery
                : props.floorplan_gallery.slice(0, 1)
        );

        const buildSwiper = async () => {
            await nextTick();
            if (swiper) {
                swiper.destroy(true, true);
                swiper = null;
            }
            const el = root.value?.querySelector('.swiper');
            if (!el) return;

            const showNav = props.options.floor_plans_loop_show_gallery
                && filtered_floorplan_gallery.value.length > 1;

            swiper = new Swiper(el, {
                modules: [Navigation],
                slidesPerView: 1,
                spaceBetween: 0,
                navigation: showNav && {
                    nextEl: el.querySelector('.swiper-button-next'),
                    prevEl: el.querySelector('.swiper-button-prev'),
                },
                observer: true,
                observeParents: true,
                updateOnImagesReady: true,
            });
        };

        onMounted(buildSwiper);
        watch(() => props.floorplan_gallery, buildSwiper);
        onBeforeUnmount(() => {
            if (swiper) {
                swiper.destroy(true, true);
                swiper = null;
            }
        });

        return {
            filtered_floorplan_gallery,
            root
        };
    },
});
</script>


